import { FunctionComponent, memo } from 'react';
import { StoryCardType } from '../../../services';
import { HorizontalStoryFeedCardProps } from '../../../shared';
import { HorizontalStoryFeedAdminArticle } from './HorizontalStoryFeedAdminArticle';
import { HorizontalStoryFeedAdminEditorial } from './HorizontalStoryFeedAdminEditorial';
import { HorizontalStoryFeedAdminEvent } from './HorizontalStoryFeedAdminEvent';
import { HorizontalStoryFeedAdminMedia } from './HorizontalStoryFeedAdminMedia';
import { HorizontalStoryFeedAdminPoll } from './HorizontalStoryFeedAdminPoll';
import { HorizontalStoryFeedAdminPost } from './HorizontalStoryFeedAdminPost';
import { HorizontalStoryFeedAdminSocial } from './HorizontalStoryFeedAdminSocial';
import { HorizontalStoryFeedAdminThread } from './HorizontalStoryFeedAdminThread';

export const HorizontalStoryFeedAdminCard: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    switch (card.type) {
      case StoryCardType.IMAGE:
      case StoryCardType.AUDIO:
      case StoryCardType.VIDEO:
      case StoryCardType.PDF:
        return <HorizontalStoryFeedAdminMedia card={card} />;
      case StoryCardType.THREAD:
        return <HorizontalStoryFeedAdminThread card={card} />;
      case StoryCardType.EDITORIAL:
        return <HorizontalStoryFeedAdminEditorial card={card} />;
      case StoryCardType.EVENT:
        return <HorizontalStoryFeedAdminEvent card={card} />;
      case StoryCardType.QUOTE:
        return <HorizontalStoryFeedAdminSocial card={card} />;
      case StoryCardType.ARTICLE:
        return <HorizontalStoryFeedAdminArticle card={card} />;
      case StoryCardType.POST:
        return <HorizontalStoryFeedAdminPost card={card} />;
      case StoryCardType.POLL:
        return <HorizontalStoryFeedAdminPoll card={card} />;
      default:
        return null;
    }
  }
);
